import * as React from 'react';
import { Box, List, Paper, Typography } from '@mui/material';
import { LanguageOutlined } from '@mui/icons-material';

interface WebsiteListProps {
    items: any[];
    emptyTitle?: string;
    emptyHint?: string;
}

export class WebsiteList extends React.Component<WebsiteListProps> {
    public render() {
        const { items, emptyTitle, emptyHint } = this.props;
        if (!items || items.length === 0) {
            return (
                <Paper
                    sx={{
                        py: 7,
                        px: 4,
                        textAlign: 'center',
                        position: 'relative',
                        overflow: 'hidden',
                        backgroundImage:
                            'radial-gradient(600px 320px at 50% -50%, rgba(5, 35, 114, 0.06), transparent 60%)',
                    }}
                >
                    <Box
                        sx={{
                            width: 64,
                            height: 64,
                            borderRadius: '20px',
                            background:
                                'linear-gradient(180deg, rgba(5, 35, 114, 0.10) 0%, rgba(5, 35, 114, 0.04) 100%)',
                            border: '1px solid rgba(5, 35, 114, 0.10)',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 2,
                            color: 'primary.main',
                            boxShadow: '0 8px 24px -12px rgba(5, 35, 114, 0.30)',
                        }}
                    >
                        <LanguageOutlined sx={{ fontSize: 28 }} />
                    </Box>
                    <Typography
                        variant="h6"
                        sx={{
                            fontFamily: '"Inter Tight", "Inter", sans-serif',
                            fontWeight: 700,
                            letterSpacing: '-0.012em',
                        }}
                    >
                        {emptyTitle ?? 'No websites yet'}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.75, maxWidth: 380, marginInline: 'auto', lineHeight: 1.55 }}
                    >
                        {emptyHint ?? 'Click "New" to spin up your first website. Builds, QA, and deploys live here.'}
                    </Typography>
                </Paper>
            );
        }
        return (
            <Paper sx={{ overflow: 'hidden' }}>
                <List component="nav" disablePadding>
                    {items}
                </List>
            </Paper>
        );
    }
}
